import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    DateField,
    EditButton,
    DeleteButton,
    Filter,
    TextInput,
    ReferenceInput,
    AutocompleteInput,
    TopToolbar,
    CreateButton,
    RefreshButton,
    useTranslate,
} from 'react-admin';
import { Box } from '@mui/material';
import { ImportCsvButton } from './ImportCsvButton';

const VehicleModelsFilter = (props: any) => {
    const translate = useTranslate();
    return (
        <Filter {...props}>
            <TextInput
                label={translate('ra.action.search')}
                source="search"
                variant="outlined"
                size="small"
                alwaysOn
            />
            <ReferenceInput
                source="brand_id"
                reference="vehicle-brands"
                perPage={1000}
                alwaysOn
            >
                <AutocompleteInput
                    label={translate('resources.vehicle-models.fields.brand', { _: 'Brand' })}
                    optionText="name"
                    variant="outlined"
                    size="small"
                />
            </ReferenceInput>
        </Filter>
    );
};

const ListActions = () => (
    <TopToolbar>
        <CreateButton />
        <ImportCsvButton />
        <RefreshButton />
    </TopToolbar>
);

export const VehicleModelsList = () => {
    const translate = useTranslate();

    return (
        <Box sx={{ position: 'relative' }}>
            <List
                filters={<VehicleModelsFilter />}
                actions={<ListActions />}
                empty={false}
                perPage={25}
                sort={{ field: 'createdAt', order: 'DESC' }}
                title={translate('resources.vehicle-models.name', { _: 'Vehicle Models' })}
                sx={{
                    '& .RaList-content': {
                        backgroundColor: '#FAFAFA',
                    },
                }}
            >
                <Datagrid
                    rowClick="edit"
                    bulkActionButtons={false}
                    sx={{
                        '& .RaDatagrid-headerCell': {
                            backgroundColor: '#F5F5F5',
                            fontWeight: 'bold',
                        },
                        '& .RaDatagrid-row': {
                            '&:hover': {
                                backgroundColor: '#F0F7FF',
                            },
                        },
                    }}
                >
                    <TextField
                        source="brand_name"
                        label={translate('resources.vehicle-models.fields.brandName', { _: 'Brand' })}
                    />
                    <TextField
                        source="name"
                        label={translate('resources.vehicle-models.fields.name', { _: 'Model' })}
                    />
                    <DateField
                        source="created_at"
                        label={translate('resources.vehicle-models.fields.createdAt', { _: 'Created' })}
                        showTime
                    />
                    <EditButton label="" />
                    <DeleteButton label="" />
                </Datagrid>
            </List>
        </Box>
    );
};
